'use client'
import React from 'react';
import Image from 'next/image';
import './player-avatar.css';

const SIZE_MAP = {
  sm: 32,
  md: 48,
  lg: 80,
  xl: 120,
};

const RANK_LABEL = { 1: '1st', 2: '2nd', 3: '3rd' };

const PlayerAvatar = ({ name = '', imageurl, size = 'md', showRank = false, rank }) => {
  const px = SIZE_MAP[size] || SIZE_MAP.md;
  const showBadge = showRank && rank >= 1 && rank <= 3;

  const renderImage = () => {
    const isOffline = typeof navigator !== 'undefined' && navigator.onLine === false;

    if (!isOffline && imageurl) {
      return (
        <Image
          src={imageurl}
          alt={name}
          width={px}
          height={px}
          loading="lazy"
          className="player-avatar__image"
          style={{ objectFit: 'cover' }}
        />
      );
    }

    return (
      <div className="player-avatar__initial" style={{ width: px, height: px }}>
        <span>{name.charAt(0).toUpperCase()}</span>
      </div>
    );
  };

  return (
    <div className={`player-avatar player-avatar--${size}`} style={{ width: px, height: px }}>
      {renderImage()}
      {showBadge && (
        <span className={`player-avatar__rank player-avatar__rank--${rank}`}>
          {RANK_LABEL[rank]}
        </span>
      )}
    </div>
  );
};

export default PlayerAvatar;
